module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/cinematic_stock-video-bkg-5e97df9c83316b25c1177ffaaeebe578.jpg";